import { render, staticRenderFns } from "./addField.vue?vue&type=template&id=2882ff26&scoped=true"
import script from "./addField.vue?vue&type=script&lang=js"
export * from "./addField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882ff26",
  null
  
)

export default component.exports